module.exports = __webpack_public_path__ + "img/sort.a6bb47dc.svg";